/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForJiraDataCenter extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForJiraDataCenter");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForJiraDataCenter.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForJiraDataCenter>): ServiceAccountNativeDetailsForJiraDataCenter {
        let obj = Object.assign(new ServiceAccountNativeDetailsForJiraDataCenter(), model);
        ServiceAccountNativeDetailsForJiraDataCenter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForJiraDataCenter>): ServiceAccountNativeDetailsForJiraDataCenter {
        if (!model) return null;
        return ServiceAccountNativeDetailsForJiraDataCenter.newInstance(<ServiceAccountNativeDetailsForJiraDataCenter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForJiraDataCenter) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForJiraDataCenter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForJiraDataCenter): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForJiraDataCenter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
